export const BASE_URL = process.env.BASE_URL
export const API_URL = process.env.VUE_APP_API_URL
